import * as React from 'react';
import { StyledContextualMenuItem, ContextualMenuItemIcon } from './styles';
import Utils from '../../../utils';
import { Translate } from 'react-redux-i18n';

interface ContextualMenuItemProps {
	label: string;
	iconName: string;
	color: string;
	size: number;
	onClick: () => void;
}

class ContextualMenuItem extends React.Component<ContextualMenuItemProps, never> {
	constructor(props: ContextualMenuItemProps) {
		super(props);
	}

	render() {
		const { label, color, iconName, size, onClick } = this.props;

		return (
			<StyledContextualMenuItem
				color={color}
				onClick={onClick}
			>
				<Translate value={label} />
				<ContextualMenuItemIcon
					size={size}
				>
					{Utils.getSvgIcon(iconName)}
				</ContextualMenuItemIcon >
			</StyledContextualMenuItem>
		);
	}
}

export default ContextualMenuItem;
export {
	ContextualMenuItemProps
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ContextualMenu/Item/index.tsx